import { render, staticRenderFns } from "./OrderGeneralTab.vue?vue&type=template&id=619c90c5&scoped=true"
import script from "./OrderGeneralTab.vue?vue&type=script&lang=js"
export * from "./OrderGeneralTab.vue?vue&type=script&lang=js"
import style0 from "./OrderGeneralTab.vue?vue&type=style&index=0&id=619c90c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c90c5",
  null
  
)

export default component.exports